<div data-row-span="12">
  <div data-field-span="2" title="{{ name }} Flight Time" class="engine-label">
    <label>
      <strong>{{ name }}</strong>
    </label>
    <input type="text" disabled readonly />
  </div>
  <div data-field-span="10" class="row-container">
    <ng-container
      *ngTemplateOutlet="
        row;
        context: {
          data: {
            engine: previous,
            label: 'Previous',
            readonly: true,
            headers: true
          }
        }
      "
    ></ng-container>
    <div data-row-span="12" [class.row-small]="false" *ngIf="current">
      <div data-field-span="1" class="fill">
        <label> <strong>INCREMENT</strong> </label>
      </div>
      <div data-field-span="2" title="{{ name }} Flight Time">
        <input type="number" [formControl]="current.time" step="0.1" />
      </div>
      <div data-field-span="1" title="{{ name }} Starts">
        <input type="number" [formControl]="current.starts" min="0" />
      </div>
      <div
        data-field-span="1"
        *ngFor="let cycle of current.cycleControls; trackBy: trackCyclesControlsBy"
        title="{{ name }}: {{ cycle.name }} Cycles"
        [flValidationState]="cycle.control"
      >
        <input type="number" [formControl]="cycle.control" min="0" />
      </div>
    </div>

    <ng-container
      *ngTemplateOutlet="row; context: { data: { engine: totals, label: 'Total', readonly: true } }"
    ></ng-container>
  </div>
</div>

<ng-template #row let-row="data">
  <div data-row-span="12" [class.row-small]="row.readonly" *ngIf="row.engine">
    <div
      data-field-span="1"
      title="{{ name }} {{ row.label }}"
      [class.readonly]="row.readonly"
      class="fill"
    >
      <label>
        <strong>{{ row.label }}</strong>
      </label>
    </div>
    <div
      data-field-span="2"
      title="{{ name }} Flight Time"
      [class.readonly]="row.readonly"
      [class.fill]="!row.headers"
    >
      <label *ngIf="row.headers">Time</label>
      <input type="number" [readonly]="row.readonly" [formControl]="row.engine.time" step="0.1" />
    </div>
    <div
      data-field-span="1"
      title="{{ name }} Starts"
      [class.readonly]="row.readonly"
      [class.fill]="!row.headers"
    >
      <label *ngIf="row.headers">Starts</label>
      <input type="number" [readonly]="row.readonly" [formControl]="row.engine.starts" min="0" />
    </div>
    <div
      data-field-span="1"
      *ngFor="let cycle of row.engine.cycleControls"
      title="{{ name }}: {{ cycle.name }} Cycles"
      [flValidationState]="cycle.control"
      [class.readonly]="row.readonly"
      [class.fill]="!row.headers"
    >
      <label *ngIf="row.headers">{{ cycle.name }}</label>
      <input type="number" [class.readonly]="row.readonly" [formControl]="cycle.control" min="0" />
    </div>
  </div>
</ng-template>
